import React from 'react'
import ZZZ6ListPage from './ZZZ6ListPage'

const ZZZ6Breadcrumb = () => <>ZZZ6</>

const zzz6Routes = [
  {
    breadcrumb: ZZZ6Breadcrumb,
    path: '',
    element: <ZZZ6ListPage />,
    children: [],
  },
]

export default zzz6Routes
